<mat-card style="width: 90%; max-width: 750px; text-align: left; margin: auto auto 150px auto;">
  <mat-card-title>
    <span class="mat-display-1">Privacy Policy</span>
  </mat-card-title>
  <mat-card-content class="ql-editor" [innerHtml]="termsHtml">
  </mat-card-content>
</mat-card>
